import { render, staticRenderFns } from "./ECGChart.vue?vue&type=template&id=f05ae50a&scoped=true&"
import script from "./ECGChart.vue?vue&type=script&lang=js&"
export * from "./ECGChart.vue?vue&type=script&lang=js&"
import style0 from "./ECGChart.vue?vue&type=style&index=0&id=f05ae50a&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f05ae50a",
  null
  
)

export default component.exports